export const moreApps = "HBa";
export default {moreApps};